import BrowserCookie from 'js-cookie'
import type { IAssetAssetRO } from 'api'

export async function fetchAssetById(id: number): Promise<IAssetAssetRO> {
  const token = BrowserCookie.get('admin_access_token')
  const response = await fetch(`${import.meta.env.VITE_API_HOST}/assets/${id}`, {
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    cache: 'no-store',
  })

  if (!response.ok) {
    throw new Error(`Failed to fetch asset ${id}`)
  }

  return response.json()
}
